import { SxProps } from "@mui/material";

export const ratingDetailsStyles: Record<string, SxProps> = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "22px",
  },
  titleText: {
    color: "var(--Dark---1000, #111)",
    fontFamily: "Montserrat",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "normal",
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  divider: {
    borderColor: "#EAECF0",
    margin: "0 -16px",
  },
  reviewMeterContainer: {
    display: "flex",
    justifyContent: "space-between",
    gap: "8px",
  },
  starsContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "4px",
  },
  starIcons: {
    display: "flex",
    alignItems: "center",
  },
  starText: {
    color: "var(--Gray-700, #4E5566)",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "150%",
  },
  progressContainer: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    flex: 1,
    justifyContent: "flex-end",
  },
  linearProgress: {
    width: "min(338px, 74%)",
    height: "8px",
    borderRadius: "0",
    backgroundColor: "#E0E0E0",
    "& .MuiLinearProgress-bar": {
      background: "var(--Warning-500, #FD8E1F)",
    },
  },
  percentageText: {
    fontFamily: "Montserrat",
    color: "var(--Gray-900, #1D2026)",
    textAlign: "right",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "normal",
    minWidth: "48px",
  },
};
